import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './carousel.css'; // Custom CSS for styling
import ArrowNew from "../../assets/Common/send.png"
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { WhatsappIcon, WhatsappShareButton } from 'react-share';
import { ExclamationCircleFill, Whatsapp, X } from 'react-bootstrap-icons';
import { Dialog, DialogPanel, Label, Menu, MenuButton, MenuItem, MenuItems, Transition, TransitionChild } from '@headlessui/react';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import RecaptchaComponent from '../commonSection/RecaptchaComponent';
import { useDispatch, useSelector } from 'react-redux';
import flags from 'react-phone-number-input/flags';
import { submitLeadForm } from '../../redux/actions/micrositeAction';
import useMicroSiteEncrypt from '../CustomHook/useMicroSiteEncrypt';
import { CheckIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

const ProductCarousel = ({ data, scrollToSection, colors, microsite_clt}) => {  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [open, setOpen] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [currentProductList, setCurrentProductList] = useState({});
  const [countryCode, setCountryCode] = useState('');
  const { microSiteEncrypt, token, error } = useMicroSiteEncrypt();
  const url_data = useSelector((state) => state.microsite?.url_data);
  const home_data = useSelector((state) => state.microsite?.home_data);
  const [message, setMessage] = useState(home_data?.whatsApp_message || " Hi, I would like to connect with you on WhatsApp to seek your financial advice.");
  const customize_fields = useSelector((state) => state.microsite?.home_data?.customization);
  const sliderRef = useRef(null);
  const [selected, setSelected] = useState({})
  const settings = {
    dots: false,
    dotsClass: "slick-dots",
    centerMode: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    draggable: isMobile ? true : currentProductList?.case_data?.length > 4,
    swipe: isMobile ? true : currentProductList?.case_data?.length > 4,
    responsive: [
      {
        breakpoint: 768, // This is the breakpoint for mobile devices
        settings: {
          slidesToShow: currentProductList?.case_data?.length > 1 ? 1.1 : 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  
  useEffect(() => {
    if (data?.length > 0) {
      setCurrentProductList(data[0]);
      setSelected(data[0]);
    }
  }, [data])
  
  const submitForm = () => {
        let payload = {
        fullname: name,
        phoneNo: countryCode+"-"+mobile?.replace(countryCode,""),
        recaptcha_token : recaptchaToken,
        url: url_data
        }
        
        const generateToken = async () => {
            const token = await microSiteEncrypt(payload);
            if (token && token !== "") {
                dispatch(submitLeadForm(token ,payload, "WhatsApp", "", onSuccess))
            }
        };
        
        generateToken();
  }
  
  const handleCountryChange = (value) => {
    if (value) {
      try {
        const phoneNumberObj = parsePhoneNumber(value);
        const countryCode = '+' + phoneNumberObj?.countryCallingCode;
        setCountryCode(countryCode);
      } catch (error) {
        console.error('Invalid phone number', error);
      }
    } else {
      setCountryCode('');
    }
  };
  
  const onSuccess = () => {
    setOpen(false);
    setName("");
    setMobile("");
  }
  
  useEffect(() => {
    if (sliderRef?.current) {
      setTimeout(() => {
        sliderRef?.current?.slickGoTo(0); // Reset to first slide  
      }, 100);
    }
  }, [currentProductList]);
  
  const handleCurrentProducts = (data) => {
    setCurrentProductList(data);
    sliderRef.current.slickGoTo(0); // Reset to first slide when category changes
  }

  const showScrollButtons = currentProductList?.case_data?.length >= 5;

  return (
    <div className={`client px-12 max-sm:px-8 py-4 mt-4 lg:max-w-7xl max-sm:max-w-fit mx-auto ${isMobile ? "" : (currentProductList?.case_data?.length < 5 ? "product-carousel":"")}`}>
        <div className='text-left max-sm:hidden flex gap-4'>
            {data?.map((item,index)=>{
              return (
                <span 
                  key={index} 
                  onClick={()=>{handleCurrentProducts(item)}} 
                  style={{
                    backgroundColor: currentProductList?.id === item?.id ? colors?.primary : 'transparent',
                    color: currentProductList?.id === item?.id ? "#fff" : colors?.textMuted,
                  }}
                  className={`cursor-pointer inline-flex border my-auto py-1.5 px-4 text-sm not-italic font-semibold shadow-sm rounded-[49px] border-solid border-[#F0F0F0] gap-2`}
                >
                    {item?.title}
                </span>
              );
            })}
            {(!microsite_clt?.whatsapp_discuss_hide || microsite_clt?.whatsapp_discuss_hide == null || microsite_clt?.whatsapp_discuss_hide == undefined || microsite_clt?.whatsapp_discuss_hide != 1  ) && (
                <span onClick={()=>{setOpen(true)}} className="inline-flex items-center cursor-pointer border bg-[#25D366] text-[#fff] my-auto py-1.5 px-4 text-sm not-italic font-semibold shadow-sm rounded-[49px] border-solid border-[#F0F0F0] gap-2">
                    Let's Discuss
                    <Whatsapp/>      
                </span>
            )}              
        </div>

        <div className='hidden max-sm:block'>
          <Menu as="div" className="relative mb-8">
            <MenuButton 
              className="relative w-full cursor-default bg-white py-3 rounded-full pl-8 pr-12 text-left shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 sm:text-sm sm:leading-6"
              style={{ 
                color: colors?.primary,
                focusRing: colors?.primary 
              }}
            >
              <span className="block truncate font-bold">{selected.title}</span>
              <span className="pointer-events-none absolute inset-y-0 right-5 flex items-center pr-2">
                <ChevronDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
              </span>
            </MenuButton>

            <MenuItems
              className="absolute z-[60] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            >
              {data?.map((item,index) => (
                <MenuItem key={item.id}>
                  {({ focus }) => (
                    <div
                      className={`group relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 ${focus ? 'bg-gray-100' : ''}`}
                      style={{
                        backgroundColor: selected?.id === item?.id ? colors?.primary : (focus ? '#f3f4f6' : 'transparent'),
                        color: selected?.id === item?.id ? "#fff" : "inherit"
                      }}
                      onClick={() => {
                        setSelected(item);
                        handleCurrentProducts(item);
                      }}
                    >
                      <span className="block truncate font-normal">{item?.title}</span>

                      {selected?.id === item?.id && (
                        <span className="absolute inset-y-0 right-0 flex items-center pr-4"
                              style={{ color: "#fff" }}>
                          <CheckIcon aria-hidden="true" className="h-5 w-5" />
                        </span>
                      )}
                    </div>
                  )}
                </MenuItem>
              ))}
            </MenuItems>
          </Menu>
        </div>
        <div className="relative w-[270px] sm:w-auto">
        {
          showScrollButtons &&
          <button
            onClick={() => sliderRef.current?.slickPrev()}
            className="absolute left-0 top-1/2 ml-3 transform -translate-y-1/2 z-[2] p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
          >
            <ChevronLeftIcon className="w-6 h-6 text-gray-700" />
          </button>
        }
        <Slider ref={sliderRef} {...settings} className='w-full py-12 max-sm:pb-0 max-sm:pt-0 text-left'>
        {currentProductList?.case_data?.map((card, c_index) => (
            <div
              key={c_index}
              style={{backgroundColor: `${colors?.primary}10`}}
              className="bg-[#F0F0F0] rounded-2xl max-sm:rounded-2xl text-gray-600 max-sm:p-0 overflow-hidden group relative h-[380px]  w-[270px] sm:w-auto"
            >
              <div className='p-4'>
                <div className='flex gap-2'>
                  <span
                    title={card?.cat_name}
                    style={{
                      backgroundColor: `${colors?.primary}1A`, // 10% opacity
                      color: colors?.primary
                    }}
                    className="inline-flex rounded-md text-xs not-italic font-medium leading-4 items-center px-2 py-1 ring-1 ring-inset ring-gray-500/10"
                  >
                      {isMobile ? card?.cat_name?.length > 20 ? card?.cat_name?.slice(0,20)+"..." : card?.cat_name : card?.cat_name.length > 30 ? card?.cat_name?.slice(0,30)+"..." : card?.cat_name}
                  </span>
                </div>
                <p
                    onClick={()=>{navigate(`/category?id=${card?.cat_id}&template_id=${card?.template_id}`)}} 
                  style={{ color: colors?.primary }}
                  className='capitalize cursor-pointer hover:underline text-base my-2 not-italic font-semibold leading-6 font-sans text-left'
                >
                  {card?.title}
                </p>
                <p className='text-sm mt-2 relative transition-opacity duration-500 z-10'>
                    {card.description.slice(0,250)}
                  {card?.description?.length > 250 ?
                    <>
                      <span>...</span>
                      <span
                          onClick={()=>{navigate(`/category?id=${card?.cat_id}&template_id=${card?.template_id}`)}} 
                        style={{ color: colors?.primary }}
                        className='cursor-pointer text-xs hover:underline capitalize'
                      >
                        Read more
                      </span>
                    </>
                    : ""
                  }
                </p>
              </div>
              <img
                src={card?.microsite_img}
                className='absolute bottom-0 z-10 w-full h-[73%] transform group-hover:translate-y-[75%] transition-transform duration-500 ease-in-out rounded-b-2xl'
                alt="CardImg"
              />
            </div>
          ))}
        </Slider>
        {
          showScrollButtons &&
          <button
            onClick={() => sliderRef.current?.slickNext()}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 z-[2] p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
          >
            <ChevronRightIcon className="w-6 h-6 text-gray-700" />
          </button>
        }
      </div>
        <span onClick={()=>{setOpen(true)}} className="max-sm:inline-flex max-sm:mt-4 max-sm:mb-12 hidden items-center cursor-pointer border bg-[#25D366] text-[#fff] my-auto py-1.5 px-12 text-base not-italic font-semibold shadow-sm rounded-[49px] border-solid border-[#F0F0F0] gap-2">
            Let's Discuss
            <Whatsapp/>      
        </span>
      
        <Transition show={open}>
          <Dialog className="relative z-10" onClose={setOpen}>
            <TransitionChild
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <TransitionChild
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full max-sm:w-full sm:max-w-xl">
                    <div className="px-8 max-sm:px-4 py-4">
                    <X
                      className="absolute right-2 top-2 z-50 text-[#222] cursor-pointer text-2xl"
                        onClick={() => { setOpen(false); setMobileError(false); setNameError(false); setMobile(""); }}
                    />
                    <div className="flex justify-center m-0 p-0">
                      <WhatsappIcon className='rounded-full'/>
                    </div>
                    <div className="border-b pb-4 my-4">
                      <p className="text-[24px] max-sm:text-xl font-[TATAAIARegularPrint] text-center font-semibold">Let's Connect</p>
                    </div>
                    <form action="#" method="POST" className="my-4">
                      <div className="">
                        <div className="sm:col-span-3">
                          <div className="mt-1">
                            <textarea
                              name="message"
                              id="message"
                              rows={3}
                              className="block w-full resize-none font-[HelveticaNeueLTStd] rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset custom_ring_color sm:text-sm sm:leading-5"
                              value={message}
                              onChange={(e)=>{setMessage(e.target.value)}}
                            />
                          </div>
                        </div>    
                        <div className='flex max-sm:block mt-4 mb-8'>
                          <div className='w-1/2 max-sm:w-full max-sm:pr-0 pr-12'>
                            <div className="mt-1 relative">
                              <input
                                type="text"
                                name="name"
                                id="name"
                                className={`block w-full font-[HelveticaNeueLTStd] h-9 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ${nameError != false ? "ring-red-300 focus:ring-red-300":"ring-gray-300 custom_ring_color"}  placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-xs sm:leading-6`}
                                value={name}
                                placeholder={"Your name"+ (customize_fields?.whatsapp_contact?.name?.validation == "required" ? " *":"")}
                                onChange={(e) => {  
                                  const regex = /^[a-zA-Z ]*$/;
                                  if (regex.test(e.target.value)) {
                                    setName(e.target.value);
                                  }  
                                  if (e.target.value != "") {
                                    setNameError(false);
                                  }
                                }}
                              />
                              {nameError != false && <ExclamationCircleFill title="Enter a name" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                            </div>
                          </div>
                          <div className='w-1/2 max-sm:mt-4 max-sm:w-full'>
                            <div className="mt-1 relative country-customize delay-form">
                              <PhoneInput
                                flags={flags}  
                                className='font-[HelveticaNeueLTStd]'                                
                                placeholder={"Your mobile number"+ (customize_fields?.whatsapp_contact?.name?.validation == "required" ? " *":"")}
                                value={mobile}
                                defaultCountry="IN"
                                countryCallingCodeEditable={false}
                                international={true}  
                                limitMaxLength  
                                onChange={(e) => {
                                  handleCountryChange(e);  
                                  if (e) {
                                    setMobile(e)
                                    if (isValidPhoneNumber(e)) {
                                        setMobileError(false); 
                                    } else {
                                        setMobileError(true); 
                                    }
                                  } else {
                                    setMobile("");
                                    setMobileError(false); 
                                  }
                                }}
                              />
                              {mobileError != false && <ExclamationCircleFill title="Enter a valid mobile number" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                            </div>
                          </div>
                        </div>
                        <RecaptchaComponent onVerify={setRecaptchaToken} />
                        <button
                          type="button"
                          className={`flex w-auto mx-auto bg-[#2b9452] justify-center items-center gap-2.5 shrink-0 border px-5 pb-1 pt-1.5 rounded-[30px] border-solid border-[#fff]`}
                          onClick={() => {
                              if (name == "" && customize_fields?.whatsapp_contact?.name?.validation == "required") {
                                setNameError(true);
                                return;
                              } else if ((mobile == "" || mobileError == true) && customize_fields?.whatsapp_contact?.phone?.validation == "required" ) {
                                setMobileError(true);
                                return;
                              } else {
                                setNameError(false);
                                setMobileError(false);
                              }
                              submitForm();
                              let anchor = document.createElement('a');
                              anchor.href = `https://api.whatsapp.com/send?phone=${home_data?.microsite?.contact}&text=${message}`;
                              anchor.target = '_blank';
                              document.body.appendChild(anchor);
                              anchor.click();
                            }}
                        >
                          <span className="text-[#fff] font-[TATAAIARegularPrint] text-sm not-italic leading-5">
                            Share message
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                  </DialogPanel>
                </TransitionChild>
              </div>
            </div>
          </Dialog>
        </Transition>
    </div>
  );
};

export default ProductCarousel;